var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dongtai"},[_c('div',[_c('p',{staticClass:"name"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"maxo",domProps:{"innerHTML":_vm._s(_vm.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }